import { createEntityAdapter, EntityState } from "@ngrx/entity";
import { createReducer, on } from "@ngrx/store";
import { CopayProcedureFeeApiActions } from "../actions/action-index";
import { mapCopayProcedureFees } from "../fees/maps";
import { CopayProcedureFee } from "./copay-procedure-fee";

export const featureKey = "copayProcedureFees";

export type CopayProcedureFeeState = EntityState<CopayProcedureFee>

export const adapter = createEntityAdapter<CopayProcedureFee>({
  selectId: (copayProcFee) => copayProcFee.id,
});

export const initialState: CopayProcedureFeeState = adapter.getInitialState();

export const reducer = createReducer(
  initialState,
  on(CopayProcedureFeeApiActions.loadSuccess, (state, { copayProcedureFees }) =>
    adapter.setAll(mapCopayProcedureFees(copayProcedureFees), state)
  )
);
